import {
  Flex,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import { CalendarIcon } from "icons";
import { forwardRef, ReactElement } from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";

export const CustomDateInput = forwardRef<
  HTMLInputElement,
  { onClick?: () => void } & Pick<InputProps, "value" | "id" | "onChange">
>(({ id, onClick, value, onChange }, ref) => (
  <InputGroup onClick={onClick}>
    <Input id={id} ref={ref} value={value} onChange={onChange} />
    <InputRightElement pr={10}>
      <CalendarIcon />
    </InputRightElement>
  </InputGroup>
));

CustomDateInput.displayName = "DateInput";

const DatePickerInput = forwardRef<
  HTMLInputElement,
  Pick<
    ReactDatePickerProps,
    "onChange" | "value" | "onBlur" | "name" | "minDate" | "maxDate"
  >
>(({ name, value, onChange, ...props }, ref): ReactElement => {
  return (
    <Flex
      sx={{
        ".react-datepicker-wrapper": { width: "100%" },
      }}
    >
      <DatePicker
        selected={value ? new Date(value) : undefined}
        onChange={onChange}
        customInput={
          <CustomDateInput
            id={name}
            ref={ref}
            value={value}
            onChange={(event) => onChange(new Date(event.target.value), event)}
          />
        }
        dateFormat="dd MMM yyyy"
        isClearable
        {...props}
      />
    </Flex>
  );
});

DatePickerInput.displayName = "DatePickerInput";

export default DatePickerInput;
